import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { VideoModal } from './style'
import ReactWebMediaPlayer from 'react-web-media-player';
import dataProvider from 'shared/rest';
import { closeModal } from 'src/actions/modals';
import CloseIcon from '@material-ui/icons/Close';
import { REGEXPS } from 'shared/draft-utils/add-embeds-to-draft-js';
const { youtube } = REGEXPS;

const DATA_TEST_PRE = 'components-modals-VideoPlaybackModal-';
const VideoPlayBackModal = (props) => {
  const {
    isOpen,
    title,
    crimsonAppEventId,
    dispatch,
    uploadLink,
    isApp,
    onClose,
    ...rest
  } = props;
  const youtubeLink =
    uploadLink && uploadLink.match(youtube)
      ? uploadLink.replace('watch?v=', 'embed/')
      : '';

  const [videoUrl, setVideoUrl] = useState(youtubeLink || uploadLink);

  useEffect(() => {
    if (!videoUrl) {
      dataProvider
        .invoke('events', 'getVideoUrl', {
          crimsonAppEventId,
        })
        .then(videoUrlResult => setVideoUrl(videoUrlResult.data));
    }
  }, []);

  return (
    <VideoModal
      visible={isOpen}
      testId={`${DATA_TEST_PRE}`}
      title={title}
      footer={null}
      closeIcon={<CloseIcon />}
      onCancel={() => {
        dispatch(closeModal());
        if (onClose) {
          onClose();
        }
      }}
      {...rest}
    >
      {!youtubeLink && (
        <ReactWebMediaPlayer
          width={isApp ? 375 : 1280}
          height={isApp ? 211 : 720}
          video={videoUrl}
          thumbnail={videoUrl}
        />
      )}
      {youtubeLink && (
        <iframe
          title={`iframe-${1}`}
          width={isApp ? 375 : 1280}
          height={isApp ? 211 : 720}
          allowFullScreen={true}
          frameBorder="0"
          src={youtubeLink}
        />
      )}
    </VideoModal>
  );
};

const mapState = state => ({
  isOpen: state.modals.isOpen,
});

export default connect(mapState)(VideoPlayBackModal);